"use client";

import Link from "next/link";
import { usePolicyPageLinks } from "@webelocity/ui";

export default function PolicyFooterLinks({ className }: { className?: string }) {
  const links = usePolicyPageLinks();
  return links.map(({ subject, label, href }) => (
    <Link key={subject} href={href} className={className}>{label}</Link>
  ));
}
